const BALE_INIT_DATA_KEY = 'bale_miniapp_init_data';

export function getBaleWebApp() {
  if (typeof window === 'undefined') return null;
  return window.Bale?.WebApp
    || window.bale?.WebApp
    || window.BaleWebApp
    || window.BaleMiniApp
    || null;
}

function getStoredInitData() {
  try {
    return window.sessionStorage.getItem(BALE_INIT_DATA_KEY) || null;
  } catch {
    return null;
  }
}

function storeInitData(initData) {
  if (!initData) return;

  try {
    window.sessionStorage.setItem(BALE_INIT_DATA_KEY, initData);
  } catch {
    // The Mini App can still continue with the data provided by Bale.
  }
}

function getInitDataFromLaunchUrl() {
  if (typeof window === 'undefined') return null;

  const rawHash = window.location.hash.replace(/^#/, '').replace(/^\?/, '');
  const parameters = new URLSearchParams([
    window.location.search.replace(/^\?/, ''),
    rawHash
  ].filter(Boolean).join('&'));

  for (const key of ['initData', 'init_data', 'baleWebAppData', 'webAppData', 'tgWebAppData']) {
    const value = parameters.get(key);
    if (value) return value;
  }

  return null;
}

export function getBaleInitData() {
  const webApp = getBaleWebApp();
  if (!webApp) {
    const initData = getInitDataFromLaunchUrl() || getStoredInitData();
    storeInitData(initData);
    return initData;
  }

  webApp.ready?.();
  webApp.expand?.();

  const initData = webApp.initData || getInitDataFromLaunchUrl() || getStoredInitData();
  storeInitData(initData);
  return initData;
}

export function waitForBaleInitData(timeout = 5000, interval = 150) {
  return new Promise((resolve) => {
    const startedAt = Date.now();

    const checkInitData = () => {
      const initData = getBaleInitData();
      if (initData || Date.now() - startedAt >= timeout) {
        resolve(initData);
        return;
      }

      window.setTimeout(checkInitData, interval);
    };

    checkInitData();
  });
}

export function requestBaleContact() {
  const webApp = getBaleWebApp();
  if (!webApp?.requestContact) {
    return Promise.reject(new Error('دریافت شماره از بله در این نسخه از مینی‌اپ در دسترس نیست.'));
  }

  return new Promise((resolve, reject) => {
    try {
      webApp.requestContact((result) => {
        const contact = result?.contact || result;
        const phone = contact?.phone_number || contact?.phoneNumber || webApp.initDataUnsafe?.user?.phone_number;
        if (phone) {
          resolve(phone);
          return;
        }
        reject(new Error('شماره‌ای از بله دریافت نشد یا درخواست لغو شد.'));
      });
    } catch (error) {
      reject(error);
    }
  });
}
